import type { SwapTransaction } from 'api/changelly'

// Bridge between the session-wide CryptoSwapStatusListener (event bus, toasts)
// and the wallet's swap sheet, which stays free of ActionCable/store imports so
// it can mount on its own in the contract suite.

export type SwapStatusEvent = SwapTransaction & { previous_status?: string | null }

const listeners = new Set<(event: SwapStatusEvent) => void>()

export function publishSwapStatus(event: SwapStatusEvent) {
    listeners.forEach(listener => {
        try {
            listener(event)
        } catch (_) {
            // One bad subscriber must not starve the others.
        }
    })
}

export function subscribeSwapStatus(listener: (event: SwapStatusEvent) => void) {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
